import { Injectable } from '@angular/core';
import { Entry } from 'contentful';
import { BehaviorSubject } from 'rxjs';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { PageId } from 'src/app/shared/utilities/pageids.enum';

@Injectable({
  providedIn: 'root',
})
export class HomepagelocalNigeriaService {
  localizedHomePageData: any;
  selectedCountry?: string;

  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}
}
